export default "__VITE_ASSET__5e39c495__"